const keywords = [
  "software developer",
  "web design",
  "mobile app development company",
  "app development company",
  "app developer",
  "mobile app development",
  "app development companies",
  "mobile app development company",
  "web design company",
  "web designers",
  "ai development company",
  "ai development",
  "ai development services",
  "ai development company",
  "ai development services",
  "gen ai development company",
  "gen ai development",
  "gen ai development services",
  "gen ai development company",
  "gen ai development services",
  "crm development company",
  "crm development",
  "crm development services",
  "crm development company",
  "crm development services",
  "custom software development company",
  "custom software development",
  "custom software development services",
  "custom software development company",
  "custom software development services",
  "mobile app development company",
  "mobile app development",
  "mobile app development services",
  "mobile app development company",
  "mobile app development services",
  "website developers",
  "web development agency",
  "web development company",
  "software company",
  "software development company",
  "mobile app design",
  "company for app development",
  "app developers",
  "best software development company",
  "company for app development",
  "app developers",
];

export const system = {
  company_name: "Devkrest Technologies",
  metaData: {
    title: "Custom Software Development Company | Devkrest Technologies",
    description:
      "Devkrest builds custom software, mobile apps, and AI-powered systems for startups and businesses. India & USA. 70+ apps delivered. Book a free call.",
    keywords: keywords,
    imageUrl: "https://devkrest.com/social-preview.webp",
  },

  logoAlt: "Devkrest Technologies",
  url: "https://devkrest.com",
};
